import './ListingCard.css'

/* ── Icônes SVG ── */
const IconStar = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 3l2.6 5.9 6.4.6-4.8 4.3 1.4 6.3L12 17l-5.6 3.1 1.4-6.3-4.8-4.3 6.4-.6L12 3z"/>
  </svg>
)

const IconHeart = ({ filled }) => (
  <svg viewBox="0 0 24 24" fill={filled ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 21s-7-4.35-9.5-8.5C.5 8.5 2.5 5 6 5c2 0 3.5 1.2 4 2.3.5-1.1 2-2.3 4-2.3 3.5 0 5.5 3.5 3.5 7.5C19 16.65 12 21 12 21z"/>
  </svg>
)

const IconPin = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 21s-6.5-5.2-6.5-10.5a6.5 6.5 0 0 1 13 0C18.5 15.8 12 21 12 21z"/>
    <circle cx="12" cy="10.5" r="2"/>
  </svg>
)

const IconSyringe = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 2l4 4-2 2-1-1-7 7 1 1-2 2-1-1-2 2-3-3 2-2-1-1 2-2 1 1 7-7-1-1 2-2z"/>
  </svg>
)

const IconChip = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="7" y="7" width="10" height="10" rx="1.5"/>
    <path d="M9 2v3M15 2v3M9 19v3M15 19v3M2 9h3M2 15h3M19 9h3M19 15h3"/>
  </svg>
)

const IconDoc = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 3h7l4 4v14H7z"/><path d="M14 3v4h4"/><path d="M10 14l2 2 4-4"/>
  </svg>
)

const IconCart = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 4h2l2.4 12.4a2 2 0 0 0 2 1.6h7.2a2 2 0 0 0 2-1.6L20 8H6"/>
    <circle cx="9" cy="20" r="1"/><circle cx="17" cy="20" r="1"/>
  </svg>
)

export default function ListingCard({
  listing   = {},
  isFav     = false,
  onDetail  = () => {},
  onFav     = () => {},
  onAddCart = () => {},
}) {
  const fmt = (n) => n === 0 ? 'Gratuit' : n.toLocaleString('fr-FR') + ' €'
  const isSold = listing.status === 'sold'

  /* Tronquer la description à ~90 caractères */
  const shortDesc = listing.desc
    ? listing.desc.length > 90
      ? listing.desc.slice(0, 87).trim() + '…'
      : listing.desc
    : null

  return (
    <div className={`lcard${isSold ? ' lcard-sold' : ''}`} onClick={onDetail}>

      {/* Photo */}
      <div className="lcard-photo">
        <img
          className="lcard-img"
          src={listing.img}
          alt={listing.title}
          loading="lazy"
        />

        {/* Bandeau "Vendu" superposé sur la photo */}
        {isSold && (
          <div className="lcard-sold-overlay">
            <span className="lcard-sold-badge">Vendu</span>
          </div>
        )}

        <div className="lcard-badges">
          {listing.featured && !isSold && (
            <span className="lcard-bdg bdg-featured">
              <IconStar /> À la une
            </span>
          )}
          <span className={`lcard-bdg ${listing.sellerType === 'Pro' || listing.sellerType === 'Eleveur' ? 'bdg-pro' : listing.sellerType === 'Don' ? 'bdg-don' : 'bdg-part'}`}>
            {listing.sellerType === 'Pro' || listing.sellerType === 'Eleveur' ? 'Éleveur Pro' : listing.sellerType === 'Don' ? 'Don' : 'Particulier'}
          </span>
        </div>

        {/* Favori masqué pour les annonces vendues */}
        {!isSold && (
          <button
            className={`lcard-fav${isFav ? ' active' : ''}`}
            onClick={(e) => { e.stopPropagation(); onFav() }}
          >
            <IconHeart filled={isFav} />
          </button>
        )}

        <div className="lcard-city">
          <IconPin />
          {listing.city}
        </div>
      </div>

      {/* Contenu */}
      <div className="lcard-body">
        <div className="lcard-breed">{listing.breed}</div>
        <div className="lcard-title">{listing.title}</div>

        {shortDesc && (
          <p className="lcard-desc">{shortDesc}</p>
        )}

        {/* Badges santé */}
        <div className="lcard-health">
          {listing.vaccinated && (
            <span className="lcard-ht ht-yes">
              <IconSyringe /> Vacciné
            </span>
          )}
          {listing.microchipped && (
            <span className="lcard-ht ht-yes">
              <IconChip /> Pucé
            </span>
          )}
          {listing.pedigree && (
            <span className="lcard-ht ht-yes">
              <IconDoc /> Pédigrée
            </span>
          )}
        </div>

        <div className="lcard-footer">
          <div>
            <div className={`lcard-price${isSold ? ' lcard-price-sold' : ''}`}>{fmt(listing.price)}</div>
            <div className="lcard-price-note">
              {isSold ? 'Animal adopté' : (listing.delivery || 'Livraison incluse')}
            </div>
          </div>
          <div className="lcard-footer-actions">
            {/* Panier masqué pour les annonces vendues */}
            {!isSold && listing.sellerType !== 'Don' && (
              <button
                className="lcard-cart-btn"
                onClick={(e) => { e.stopPropagation(); onAddCart(listing) }}
                title="Ajouter au panier"
              >
                <IconCart />
              </button>
            )}
            <button
              className="lcard-cta"
              onClick={(e) => { e.stopPropagation(); onDetail() }}
            >
              Voir →
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}